type BackendUrlConfig = { REACT_APP_BACKEND_URL: string };

function assertBackendUrlConfig(value: unknown): asserts value is BackendUrlConfig {
  if (typeof value !== 'object' || value === null || typeof (value as { REACT_APP_BACKEND_URL?: unknown }).REACT_APP_BACKEND_URL !== 'string') {
    throw new Error('config.json is malformed: missing or non-string REACT_APP_BACKEND_URL');
  }
}

export const getBackendUrl = async (): Promise<string> => {
  try {
    const response = await fetch('/config.json', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error('Failed to load config.json');
    }
    const config: unknown = await response.json();
    assertBackendUrlConfig(config);
    return config.REACT_APP_BACKEND_URL;
  } catch (error) {
    console.error('Error loading backend URL from config.json:', error);
    // Fallback to the dynamic URL generation if config.json is not
    // available, fails to load, or doesn't contain a usable URL.
    const frontendDomain = window.location.hostname;
    return `https://api.${frontendDomain}`;
  }
};
